import React from 'react';

import styles from './styles.module.scss';
import { Grid, Divider, Col, Row } from '@components/Grid';
import { Link } from 'gatsby';
import Button from '@components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <Grid>
                <Row>
                    <Col md={12} lg={12} xl={9}>
                        <div className={styles.footerLinks}>
                            <Row center="xs" start="md">
                                <Col md={4} lg={4}>
                                    <dl>
                                        <dt>Customer Care</dt>
                                        <dd>
                                            <Link
                                                className={styles.footerLinksLink}
                                                to="/who-are-we"
                                            >
                                                Who Are We
                                            </Link>
                                        </dd>
                                        <dd>
                                            <Link
                                                className={styles.footerLinksLink}
                                                to="/shipping-policy"
                                            >
                                                Shipping Policy
                                            </Link>
                                        </dd>
                                        <dd>
                                            <Link
                                                className={styles.footerLinksLink}
                                                to="/return-policy"
                                            >
                                                Return Policy
                                            </Link>
                                        </dd>
                                        <dd>
                                            <Link className={styles.footerLinksLink} to="/frequently-asked-questions">
                                                Frequently Asked Questions
                                            </Link>
                                        </dd>
                                        <dd>
                                            <Link
                                                className={styles.footerLinksLink}
                                                to="/suppressor-purchase-information"
                                            >
                                                Suppressor Purchases
                                            </Link>
                                        </dd>
                                        <dd>
                                            <Link
                                                className={styles.footerLinksLink}
                                                to="/newsletter-signup"
                                            >
                                                Newsletter Signup
                                            </Link>
                                        </dd>
                                    </dl>
                                    <Divider xs={3} />
                                </Col>
                                <Col md={4} lg={4}>
                                    <dl>
                                        <dt>Find A Dealer</dt>
                                        <dd>
                                            <Button link="/dealers-locations">Find Dealers</Button>
                                        </dd>
                                    </dl>
                                    <Divider xs={3} />
                                </Col>
                                <Col md={4} lg={4}>
                                    <dl>
                                        <dt>Become A Dealer</dt>
                                        <dd>
                                            <Button text="Dealer Signup" link="/dealer-sign-up" />
                                        </dd>
                                    </dl>
                                    <Divider xs={3} />
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    <Col md={12} lg={12} xl={3}>
                        <Divider xsMargin={3} lgMargin={0} />
                        <Row center="xs" start="xl">
                            <Col>
                                <ul className={styles.footerSocial}>
                                    <li>
                                        <a
                                            aria-label="Facebook"
                                            href="https://www.facebook.com/sylvanarms/?pageid=823267474496712"
                                            rel="noopener noreferrer"
                                        >
                                            <FontAwesomeIcon icon={['fab', 'facebook-f']} />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            aria-label="TikTok"
                                            href="https://tiktok.com"
                                            rel="noopener noreferrer"
                                        >
                                            <FontAwesomeIcon icon={['fab', 'tiktok']} />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            aria-label="Instagram"
                                            href="https://www.instagram.com/sylvanarms/?hl=en"
                                            rel="noopener noreferrer"
                                        >
                                            <FontAwesomeIcon icon={['fab', 'instagram']} />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            aria-label="Youtube"
                                            href="https://www.youtube.com/channel/UCjc9Fw4gnPGHUG-Ju21ivyg"
                                            rel="noopener noreferrer"
                                        >
                                            <FontAwesomeIcon icon={['fab', 'youtube']} />
                                        </a>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider xsMargin={3} lgMargin={0} />
            </Grid>
        </footer>
    );
};

export default Footer;
